import { Questionnaire } from 'commons/types/DTO/bank/quarterlyReport/questionnaire'

export interface QuestionnaireFormProps {
  setQuestionnaire: (questionnaire: Questionnaire) => void
  questionnaire: Questionnaire
}
